(function () {
  'use strict';

  // 1. HEADER STICKY
  function initStickyHeader() {
    const header = document.querySelector('.header, .site-header, header[role="banner"]');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      if (current > 80) header.classList.add('header--scrolled');
      else header.classList.remove('header--scrolled');
      header.style.transform = (current > lastScroll && current > 200) ? 'translateY(-100%)' : 'translateY(0)';
      lastScroll = current;
    }, { passive: true });
  }

  // 2. ANIMACIONES SCROLL
  function initScrollAnimations() {
    const targets = document.querySelectorAll('.card-wrapper, .card, .product-card, .sc-value-card, .sc-stat, .sc-trust-item');
    targets.forEach((el, i) => { el.classList.add('sc-animate', `sc-animate--delay-${(i % 4) + 1}`); });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('sc-visible'); observer.unobserve(entry.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.sc-animate').forEach(el => observer.observe(el));
  }

  // 3. CONTADORES ANIMADOS
  function animateCounter(el, target, suffix) {
    const duration = 1800, start = performance.now();
    const tick = (now) => {
      const ease = 1 - Math.pow(1 - Math.min((now - start) / duration, 1), 3);
      el.textContent = Math.floor(ease * target) + suffix;
      if (ease < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  function initCounters() {
    const statsSection = document.querySelector('.sc-stats');
    if (!statsSection) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        document.querySelectorAll('.sc-stat__number[data-target]').forEach(el => {
          animateCounter(el, parseFloat(el.dataset.target), el.dataset.suffix || '');
        });
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    observer.observe(statsSection);
  }

  // 4. HERO
  function injectHero() {
    if (document.querySelector('.sc-hero, [class*="hero__banner"], .banner')) return;
    const main = document.querySelector('#MainContent, main');
    if (!main) return;
    const hero = document.createElement('section');
    hero.className = 'sc-hero';
    hero.innerHTML = `
      <div class="sc-hero__eyebrow">Distribuidores de confianza en El Salvador</div>
      <h1 class="sc-hero__title">Insumos de <span>Alta Calidad</span><br>para tu Empresa</h1>
      <p class="sc-hero__subtitle">Proveemos al sector salud, industrial y alimenticio con productos certificados, precios competitivos y entrega a todo el país.</p>
      <a href="/collections" class="sc-hero__cta">Ver Catálogo →</a>
      <a href="/pages/contact" class="sc-hero__cta-secondary">Solicitar Cotización</a>`;
    main.insertBefore(hero, main.firstChild);
  }

  // 5. STATS BAR
  function injectStats() {
    if (document.querySelector('.sc-stats')) return;
    const hero = document.querySelector('.sc-hero, [class*="hero__banner"], .banner');
    const stats = document.createElement('div');
    stats.className = 'sc-stats';
    stats.innerHTML = `
      <div class="sc-stat"><div class="sc-stat__number" data-target="500" data-suffix="+">0+</div><div class="sc-stat__label">Clientes atendidos</div></div>
      <div class="sc-stat"><div class="sc-stat__number" data-target="50" data-suffix="+">0+</div><div class="sc-stat__label">Productos disponibles</div></div>
      <div class="sc-stat"><div class="sc-stat__number" data-target="100" data-suffix="%">0%</div><div class="sc-stat__label">Envíos a todo el país</div></div>
      <div class="sc-stat"><div class="sc-stat__number" data-target="24" data-suffix="h">0h</div><div class="sc-stat__label">Tiempo de entrega</div></div>`;
    if (hero) hero.insertAdjacentElement('afterend', stats);
    initCounters();
  }

  // 6. TRUST BAR
  function injectTrustBar() {
    if (document.querySelector('.sc-trust-bar')) return;
    const footer = document.querySelector('.footer, .site-footer, footer[role="contentinfo"]');
    if (!footer) return;
    const trust = document.createElement('div');
    trust.className = 'sc-trust-bar';
    trust.innerHTML = `<div class="sc-trust-bar__inner">
      <div class="sc-trust-item"><div class="sc-trust-item__icon">🚚</div><div><strong>Envío Gratis</strong><span>A todo El Salvador</span></div></div>
      <div class="sc-trust-item"><div class="sc-trust-item__icon">✅</div><div><strong>Productos Certificados</strong><span>Calidad garantizada</span></div></div>
      <div class="sc-trust-item"><div class="sc-trust-item__icon">💼</div><div><strong>Ventas B2B</strong><span>Precios al por mayor</span></div></div>
      <div class="sc-trust-item"><div class="sc-trust-item__icon">📞</div><div><strong>Soporte Dedicado</strong><span>Atención personalizada</span></div></div>
    </div>`;
    footer.insertAdjacentElement('beforebegin', trust);
  }

  // 7. WHATSAPP FLOTANTE — CAMBIA EL NÚMERO AQUÍ ↓
  function injectWhatsApp() {
    const phone = '50378901234'; // ← PON TU NÚMERO (503 + tu número sin guiones)
    const msg = encodeURIComponent('Hola, me gustaría solicitar una cotización.');
    const btn = document.createElement('a');
    btn.href = `https://wa.me/${phone}?text=${msg}`;
    btn.target = '_blank'; btn.rel = 'noopener';
    btn.innerHTML = `<svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`;
    const style = document.createElement('style');
    style.textContent = `.sc-wa{position:fixed;bottom:28px;right:28px;z-index:9999;width:60px;height:60px;background:#25D366;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 20px rgba(37,211,102,.5);transition:all .25s ease;animation:wapulse 2.5s infinite}
    .sc-wa:hover{background:#1EBE56;transform:scale(1.1);color:#fff}
    @keyframes wapulse{0%,100%{box-shadow:0 4px 20px rgba(37,211,102,.5)}50%{box-shadow:0 4px 36px rgba(37,211,102,.8)}}`;
    btn.className = 'sc-wa';
    document.head.appendChild(style);
    document.body.appendChild(btn);
  }

  // INIT
  function init() {
    initStickyHeader(); injectHero(); injectStats(); injectTrustBar();
    initScrollAnimations(); injectWhatsApp();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();